export const redirectToUrl = (url: string) => {
    window.location.replace(url);
};
